import { putRestRequest } from '../../../helpers/RestHelpers'
import { api } from '../../../configuration'
import { SimpleResult } from '../../types/PaginatedResult'
import { SClassifiedMedia } from '../../types/api/Classified'
import { classifiedMediaTransformer } from '../../transformers/classifiedTransformer'

type UpdateMediaResponse = SimpleResult<SClassifiedMedia>

export type UpdateMediaParams = {
  id: string
  data: { [key: string]: any }
}

const updateMedia = ({ id, data }: UpdateMediaParams) => {
  return putRestRequest({
    url: api.REST_API_URL + `/classified-medias/${id}`,
    data: { data },
    transformer: (response: UpdateMediaResponse) => {
      return classifiedMediaTransformer(response.data)
    },
  })
}

export default updateMedia
